import { Modal, Stack } from "react-bootstrap";

export interface ISwitchingZonesModalProps {
    onCancel: () => void;
    onClose: () => void;
    onSubmit: () => void;
    open: boolean;
}

export function SwitchingZonesModal(props: ISwitchingZonesModalProps) {
    return (
        <Modal centered show={props.open} backdrop>
            <Modal.Header>
                <Modal.Title>Switch Zones</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Stack gap={3}>
                    <div>
                        The documents you are accessing belong to a different zone. <br />
                        Would you like to switch zones?
                    </div>
                </Stack>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-black" onClick={props.onSubmit}>
                    Switch
                </button>
                <button className="btn btn-default" onClick={props.onCancel}>
                    Cancel
                </button>
            </Modal.Footer>
        </Modal>
    );
}
